<template>
  <div>
    <TomSelect
      @change="$emit('change', $event.target.value)"
      :class="usedClass"
      :options="{
        maxItems: 1,
        loadThrottle: 250,
        placeholder: 'Type to get a list of benchmarks',
        valueField: 'ticker',
        labelField: 'description',
        searchField: ['description', 'ticker'],
        optgroups: [
          { value: 'Preferred', label: 'Preferred' },
          { value: 'All', label: 'All' }
        ],
        optgroupField: 'group',
        preload: true,
        render: {
          item: function (data, escape) {
            return '<div>' +
              '<strong>' + data.ticker + '</strong> ' +
              data.description +
              '</div>';
          },
          option: function (data, escape) {
            return '<div>' +
              '<strong>' + data.ticker + '</strong> ' +
               data.description +
              '</div>';
          }
        },
        load: function (str, callback) {
          onBenchmarkLoad(str)
            .then((searchResults) => {
              callback(searchResults)
              if (this.times !== 1) {
                this.times = 1
                this.addItem(value)
              }
            })
            .catch(() => callback())
        },
      }"
    />
  </div>
</template>

<script>
import tomSelectGroupParser from '@/domain/services/TomSelectGroupParser'
import { defineComponent } from 'vue'
import { useStore } from 'vuex'
import PortfolioFormTransformer from '@/domain/services/PortfolioFormTransformer'

export default defineComponent({
  emits: ['change'],
  props: {
    value: String,
    usedClass: Object
  },
  setup(props) {
    const store = useStore()

    const onBenchmarkLoad = (str) => {
      if (props.value.length > 0 && str.length === 0) {
        return onSearchBenchmark(props.value)
          .then((searchResults) => {
            return onSearchPreferredBenchmark()
              .then((fillResults) => [...fillResults, ...searchResults])
          })
      }
      if (str.length === 0) {
        return onSearchPreferredBenchmark()
          .then((searchResults) => searchResults)
      }
      return onSearchBenchmark(str)
        .then((searchResults) => searchResults)
    }

    const onSearchBenchmark = (search) => store.dispatch('searchBenchmarks', search)
      .then(searchResult => {
        return tomSelectGroupParser(searchResult.getData, 'All')
      })

    const onSearchPreferredBenchmark = (search) => store.dispatch('searchPreferredBenchmarks', search)
      .then(preferredResult => {
        const preferredData = tomSelectGroupParser(preferredResult.getData, 'Preferred')
        return onSearchBenchmark('a')
          .then(allData => {
            return [...preferredData, ...allData];
          })
      })

    return {
      PortfolioFormTransformer,
      onBenchmarkLoad,
    }
  }
})
</script>
